import React, { useEffect } from "react";
import styles from "../categories_menu.module.css";
import MenuItem from "../menu_item/menu_item";
import { useSelector, useDispatch } from "react-redux";
import {
  getMenuCategories, getLoading
} from "../../../services/selectors";
import { useLocation } from "react-router-dom";
import { MENU_CATEGORIES_CHANGE } from "../../../services/actions/menu_categories_actions";


export const menuFromCategories = (categories) => {
  let menu = [];
  categories.forEach(category => {
    if (category.children.length) {
      menu.push({
        id: category.id,
        name: category.name,
        path: category.path,
        parent: category.parent,
        count_products: category.count_products,
        total_products: category.total_products,
        count_active_products: category.count_products,
        total_active_products: category.total_products,
        isOpen: false,
        children: [...menuFromCategories(category.children)]
      });
    } else {
      menu.push({
        id: category.id,
        name: category.name,
        path: category.path,
        parent: category.parent,
        count_products: category.count_products,
        total_products: category.total_products,
        count_active_products: category.count_products,
        total_active_products: category.total_products,
        isOpen: false,
        children: []
      });
    }
  });
  return menu;
}

export const deepFindByPath = (list, path) => {
  for (const item of list) {
    if (item.path === path) {
      return item;
    }
    if (item.children.length) {
      const found = deepFindByPath(item.children, path);
      if (found) return found;
    }
  }
  return null;
};


const MenuContainer = () => {

  const { menuCategories } = useSelector(getMenuCategories);

  const location = useLocation();
  const isLoading = useSelector(getLoading);
  const dispatch = useDispatch();

  const deepFindById = (list, id) => {
    for (const item of list) {
      if (item.id === id) {
        return item;
      }
      if (item.children.length) {
        const found = deepFindById(item.children, id);
        if (found) return found;
      }
    }
    return null;
  };

  const getParentsIdList = (list, id) => {
    let parentsList = [];
    let currId = id;
    let currElement = deepFindById(list, currId);;
    if (!currElement) return [];
    while (currElement?.parent) {
      currId = currElement.parent;
      currElement = deepFindById(list, currId);
      parentsList.push(currId);
    }
    return parentsList;
  }

  const changevisibleItems = (list, opensList) => {
    let newList = [];
    list.forEach(item => {
      const openStatus = !!opensList.find(i => i === item.id);
      if (item.children.length) {
        newList.push({
          id: item.id,
          name: item.name,
          path: item.path,
          parent: item.parent,
          count_products: item.count_products,
          total_products: item.total_products,
          count_active_products: item.count_products,
          total_active_products: item.total_products,
          isOpen: openStatus,
          children: [...changevisibleItems(item.children, opensList)]
        });
      } else {
        newList.push({
          id: item.id,
          name: item.name,
          path: item.path,
          parent: item.parent,
          count_products: item.count_products,
          total_products: item.total_products,
          count_active_products: item.count_products,
          total_active_products: item.total_products,
          isOpen: openStatus,
          children: []
        });
      }
    });
    return newList;
  }

  const handleChangeVisibility = (list, id) => {
    let opensList = [];
    if (location.pathname === '/catalog' || !deepFindById(list, id)) return changevisibleItems(list, []);

    if (!deepFindById(list, id).isOpen) {
      opensList = [id, ...getParentsIdList(list, id)];
    } else {
      opensList = getParentsIdList(list, id);
    }
    return changevisibleItems(list, opensList);
  }

  useEffect(() => {
    if (menuCategories.length && location.pathname.startsWith('/catalog/') && !isLoading) {
      const currCategory = deepFindByPath(menuCategories, location.pathname);
      dispatch({
        type: MENU_CATEGORIES_CHANGE,
        payload: handleChangeVisibility(menuCategories, currCategory?.id || -1, false)
      });
    }
    if (location.pathname === '/catalog') {
      dispatch({
        type: MENU_CATEGORIES_CHANGE,
        payload: changevisibleItems(menuCategories, [])
      });
    }
    // eslint-disable-next-line
  }, [location.pathname]);




  return (
    <ul className={styles.container}>
      {menuCategories.map((categorie, index) => {
        return (
          <li key={index} className={styles.container_item}>
            <MenuItem
              handleChangeVisibility={handleChangeVisibility}
              menuCategories={menuCategories} categorie={categorie}
            />
          </li>
        )
      })}
    </ul>
  );
}

export default MenuContainer;
